import { useEffect } from "react";
import { FormActions } from "../../components/common/FormActions";
import {
  API_INTERNAL_MERCHANT_ACCESS,
  API_INTERNAL_MERCHANTS,
} from "../../utils/apis";
import {
  createDeleteAction,
  createEditAction,
  createViewAction,
  formatDate,
  getForm,
  getRegister,
} from "../../utils/helpers";
import { URL_INTERNAL_MERCHANT_ACCESS } from "../../utils/urls";
import useGet from "../common/useGet";
import { BooleanTags } from "../../components/common/registerUtils";

const url = URL_INTERNAL_MERCHANT_ACCESS;

// REGISTER
export const useInternalMerchantAccess = () => {
  const tableColumns = () => [
    {
      id: "business_name",
      header: "Merchant Name",
      filter: {},
    },
    {
      id: "merchant_number",
      header: "Merchant Number",
      filter: {},
    },
    {
      id: "active",
      header: "Status",
      filter: {},
    },
    {
      id: "qr_code_payments",
      header: "QR Code Payment",
      filter: {},
    },
    {
      id: "merchant_code_payments",
      header: "Merchant Code Payment",
      filter: {},
    },
    {
      id: "nfc_card_payments",
      header: "NFC Card Payment",
      filter: {},
    },
    {
      id: "created_at",
      header: "Created At",
      filter: {},
    },
    {
      id: "created_by",
      header: "Created By",
      filter: {},
    },
    {
      id: "actions",
      header: "Actions",
    },
  ];
  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        qr_code_payments: <BooleanTags status={item?.qr_code_payments} />,
        merchant_code_payments: (
          <BooleanTags status={item?.merchant_code_payments} />
        ),
        nfc_card_payments: <BooleanTags status={item?.nfc_card_payments} />,
        active: <BooleanTags status={item?.active} />,
        created_by:
          `${item?.created_by?.first_name} ${item?.created_by?.last_name}` ||
          "N/A",
        created_at: formatDate(item?.created_at),

        actions: (
          <FormActions
            actions={[
              createViewAction(url, item?.id),
              createDeleteAction(
                `${API_INTERNAL_MERCHANT_ACCESS}${item?.id}/`,
                `${item?.merchant}`,
              ),
              createEditAction(url, item?.id),
            ]}
          />
        ),
      };
    }),
  ];

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Internal Merchant Access Details",
          fields: {
            merchant: item?.merchant,
            merchant_number: item?.merchant_number,
            active: <BooleanTags status={item?.active} />,
            qr_code_payments: <BooleanTags status={item?.qr_code_payments} />,
            merchant_code_payments: (
              <BooleanTags status={item?.merchant_code_payments} />
            ),
            nfc_card_payments: <BooleanTags status={item?.nfc_card_payments} />,
            created_by:
              `${item?.created_by?.first_name} ${item?.created_by?.last_name}` ||
              "N/A",
            created_on: formatDate(item?.created_at),
          },
        },
      ],
    };
  };

  const formRoute = getForm(url);

  const tableTitle = "Internal Merchant Access";

  return { tableData, tableColumns, formRoute, viewData, tableTitle };
};

// FORM
export const usePaymentAccessMatrixForm = () => {
  const { loadData, loading, data: merchantsData } = useGet();

  useEffect(() => loadData({ api: API_INTERNAL_MERCHANTS }), []);

  const sections: any = [
    {
      title: "Internal Merchant Access Details",
      fields: [
        {
          field_name: "merchant",
          label: "Merchant",
          type: "select",
          options_data: merchantsData?.results?.map((item: any) => {
            return {
              id: item?.id,
              name: item?.name,
            };
          }),
          loading,
        },
        {
          field_name: "active",
          type: "select",
          props: {
            required: true,
          },
          options_data: [
            { id: true, name: "Yes" },
            { id: false, name: "No" },
          ],
        },
        {
          field_name: "qr_code_payments",
          type: "select",
          props: {
            required: true,
          },
          options_data: [
            { id: true, name: "Yes" },
            { id: false, name: "No" },
          ],
        },
        {
          field_name: "merchant_code_payments",
          type: "select",
          props: {
            required: true,
          },
          options_data: [
            { id: true, name: "Yes" },
            { id: false, name: "No" },
          ],
        },
        {
          field_name: "nfc_card_payments",
          type: "select",
          props: {
            required: true,
          },
          options_data: [
            { id: true, name: "Yes" },
            { id: false, name: "No" },
          ],
        },
      ],
    },
  ];

  const redirect = getRegister(url);
  // SUBMIT
  function onSubmit(payload: any, id: string | number) {
    let params = { ...payload };

    return {
      id,
      api: API_INTERNAL_MERCHANT_ACCESS,
      params,
    };
  }

  return { sections, redirect, onSubmit };
};
